module.exports = __webpack_public_path__ + "static/media/hackathon-of-humanoid-robots-4.ad726393.png";